import { render, staticRenderFns } from "./RegistrationCard.vue?vue&type=template&id=50918e83"
import script from "./RegistrationCard.vue?vue&type=script&lang=js"
export * from "./RegistrationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports